import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const getToken = () => {
  const rawToken =
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("token");

  if (!rawToken) {
    throw new Error("Token não encontrado.");
  }

  return rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
};

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

const getApiErrorMessage = (err, fallbackMessage) => {
  const responseData = err?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) return responseData;
  if (responseData?.mensagem) return responseData.mensagem;
  if (responseData?.message) return responseData.message;
  if (responseData?.erro) return responseData.erro;
  if (responseData?.detail) return responseData.detail;

  if (err?.response?.status === 401) return "Sessão expirada ou token inválido.";
  if (err?.response?.status === 403) return "Cliente sem acesso ativo ao produto Cobrança.";

  return err?.message || fallbackMessage;
};

const getDashboard = async () => {
  const response = await axios.get(`${baseURL}/produto/cobranca/dashboard`, {
    headers: authHeaders(),
  });

  return response?.data || null;
};

const cobrancaDashboardService = {
  getApiErrorMessage,
  getDashboard,
};

export default cobrancaDashboardService;
